/** t368u: HR queries, kept small so the settings list can check "is HR on?" without loading the HR screens. */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useWorkspaceId } from '@/lib/hooks';
import { queryClient } from '@/lib/queryClient';

export const hrKey = (ws: string | null | undefined, who: string) => ['hr', ws ?? '', who] as const;
export function useHrSettings() {
  const ws = useWorkspaceId();
  return useQuery({ queryKey: hrKey(ws, 'settings'), queryFn: () => api.hr.settings(ws!), enabled: Boolean(ws), staleTime: 60_000, retry: false });
}
/** `me` for your own record, else the person's id. Opening someone else's record is audited by the API. */
export function useHrRecord(who: string, enabled = true) {
  const ws = useWorkspaceId();
  return useQuery({ queryKey: hrKey(ws, who), queryFn: () => (who === 'me' ? api.hr.me(ws!) : api.hr.record(ws!, who)), enabled: Boolean(ws) && enabled, retry: false, staleTime: 0 });
}
export const refreshHr = (ws: string | null | undefined) => queryClient.invalidateQueries({ queryKey: ['hr', ws ?? ''] });
